import React from 'react'
import { withStyles, createStyles } from '@material-ui/core/styles'

import { ITank } from 'types'

const annularSector = (
  centerX: number,
  centerY: number,
  startAngle: number,
  endAngle: number,
  innerRadius: number,
  outerRadius: number,
) => {
  const deg2rad = (deg: number) => {
    return (deg * Math.PI) / 180
  }

  startAngle = deg2rad(startAngle + 180)
  endAngle = deg2rad(endAngle + 180)

  const p = [
    [centerX + innerRadius * Math.cos(startAngle), centerY + innerRadius * Math.sin(startAngle)],
    [centerX + outerRadius * Math.cos(startAngle), centerY + outerRadius * Math.sin(startAngle)],
    [centerX + outerRadius * Math.cos(endAngle), centerY + outerRadius * Math.sin(endAngle)],
    [centerX + innerRadius * Math.cos(endAngle), centerY + innerRadius * Math.sin(endAngle)],
  ]

  const angleDiff = endAngle - startAngle
  const largeArc = angleDiff % (Math.PI * 2) > Math.PI ? 1 : 0

  const commands = []

  commands.push('M' + p[0].join())
  commands.push('L' + p[1].join())
  commands.push('A' + [outerRadius, outerRadius].join() + ' 0 ' + largeArc + ' 1 ' + p[2].join())
  commands.push('L' + p[3].join())
  commands.push('A' + [innerRadius, innerRadius].join() + ' 0 ' + largeArc + ' 0 ' + p[0].join())
  commands.push('z')

  return commands.join(' ')
}

const styles = ({ breakpoints }) =>
  createStyles({
    gaugeimg: {
      position: 'absolute',
      bottom: 0,
      width: '50%',
      marginLeft: 'auto',
      marginRight: 'auto',
      left: 0,
      right: 0,
    },
  })

interface IProps {
  tank: ITank
  classes: any
}

const Manifold = ({ tank, classes }: IProps) => {
  const value = Math.min(100, Math.max(Math.round(parseFloat(tank.info.value) * 100), 0))

  const arcColour = value < 60 ? '#ff7f50' : '#7FCD98'
  const textColour = '#827066'

  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        position: 'relative',
        width: '90%',
      }}
    >
      <div className={classes.gaugeimg}>
        <img style={{ width: '100%' }} src="/images/icons/manifold.svg" />
      </div>
      <svg viewBox="0 0 200 210">
        <g transform="translate(100,100)">
          <path
            className="background-arc"
            d={annularSector(0, 0, -45, 225, 70, 95)}
            style={{ fill: 'rgb(238, 238, 238)' }}
          />
          <path
            className="foreground"
            d={annularSector(0, 0, -45, (value / 100) * 225, 70, 95)}
            style={{ fill: arcColour }}
          />
          <text
            textAnchor="middle"
            fontSize="50px"
            fontWeight="bold"
            style={{ fill: textColour }}
            transform={`translate(${value < 10 ? -5 : value < 100 ? -10 : -13}, 0)`}
          >
            {value}
          </text>
          <text
            textAnchor="middle"
            fontSize="16px"
            fontWeight="bold"
            style={{ fill: textColour }}
            transform={`translate(${value < 10 ? 20 : value < 100 ? 30 : 38}, -15)`}
          >
            %
          </text>
        </g>
      </svg>
    </div>
  )
}

export default withStyles(styles)(Manifold)
